import { render } from "./CategoryServiceImaging.vue?vue&type=template&id=3ecc90d9&scoped=true&ts=true"
import script from "./CategoryServiceImaging.vue?vue&type=script&lang=ts"
export * from "./CategoryServiceImaging.vue?vue&type=script&lang=ts"

import "./CategoryServiceImaging.vue?vue&type=style&index=0&id=3ecc90d9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecc90d9"]])

export default __exports__